import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  formHeader: {
    display: 'flex',
    flexDirection: 'row'
  },
  fieldRow: {
    display: 'block',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  },
  field: {
    margin: theme.spacing()
  },
  fieldSelect: {
    minWidth: 180,
    height: 40,
    margin: theme.spacing()
  },
  imagePicker: {
    flexGrow: '4',
    cursor: 'pointer',
    width: 400,
    height: 300,
    margin: '0 auto',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'lightgray'
  },
  actionsContainer: {
    borderTop: 'solid 1px',
    borderTopColor: theme.palette.grey[400],
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(),
    '& button': {
      marginRight: theme.spacing()
    }
  },
  containerColor: {
    display: 'flex',
    alignItems: 'center'
  },
  colorInput: {
    maxWidth: 200,
    margin: theme.spacing()
  },
  colorField: {
    width: 49,
    height: 49,
    border: 'none',
    marginLeft: 8,
    marginRight: 16,
    cursor: 'pointer'
  }
}))

export default useStyles
